import template from "./pClientGroups.html";

export function pClientGroupsDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pClientGroupsController,
    controllerAs: 'pClientGroups',
    bindToController: true
  };

  return directive;
}

class pClientGroupsController {
  constructor(Auth, Admin, $scope, $interval, Notes, ConnectionQuality) {
    'ngInject';

    this.Auth = Auth;
    this.Admin = Admin;
    this.$scope = $scope;
    this.$interval = $interval;
    this.Notes = Notes;
    this.ConnectionQuality = ConnectionQuality;

    this.init();

    this.fields = {
      name: "info"
    };

    this.actions = [
      {
        name: "new",
        functionName: "startAddingNewClientGroup",
        fa: "fa-plus"
      }
    ];

    this.rowActions = [
      {
        name: "edit",
        functionName: "startEditingClientGroup",
        fa: "fa-pencil-alt"
      },
      {
        name: "delete",
        functionName: "startDeletingClientGroup",
        fa: "fa-trash"
      }
    ];

    /*
    *
    */

    this.newClientGroupData = {
      name: {
        type: "text"
      }
    };

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  init() {
    this.state = 'loading';
    this.Auth.authorizeAdmin().then(
      (user) => {
        this.user = user;
        this.Admin.getClientGroups().then(
          (success) => {
            this.clientGroups = success.data.sort((a, b) => {
              if (a.name < b.name) {
                return -1;
              }
              if (a.name > b.name) {
                return 1;
              }

              return 0;
            });
            this.state = 'loaded';
          },
          (error) => {
            this.state = 'loaded';
            this.Notes.postNote({type: "error", error: error});
          }
        );

        var timeout = this.$interval(() => {
          this.notes = this.Notes.getNotes();
        }, 10);
        this.$scope.$on("$destroy", () => {this.$interval.cancel( timeout);});
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );
  }

  startAddingNewClientGroup() {
    this.newClientGroupValues = null;
    this.newClientGroupProcess = true;
  }

  addNewClientGroup(group) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    this.Admin.addClientGroup(group).then(
      () => {
        this.newClientGroupProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  startEditingClientGroup(group) {
    this.editClientGroupProcess = true;
    this.editClientGroupValues = angular.fromJson(angular.toJson(group));
  }

  updateClientGroup(group) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    this.Admin.updateClientGroup(group.id, group).then(
      () => {
        this.editClientGroupProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  startDeletingClientGroup(group) {
    this.deleteClientGroupProcess = true;
    this.deleteClientGroupValues = angular.fromJson(angular.toJson(group));
  }

  deleteClientGroup(group) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    this.Admin.deleteClientGroup(group.id).then(
      () => {
        this.deleteClientGroupProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }
}
